import type {} from 'svelte'; // Allow Svelte compontents to be handled correctly with TypeScript

import BuyGlobalPassModal from '../../components/BuyGlobalPass.svelte';
import ModalBookingSuccess from '../../components/ModalBookingSuccess.svelte';
import ModalBookingTryAgain from '../../components/ModalBookingTryAgain.svelte';

import type {HydrateJSON, Response} from '../../components/BuyGlobalPass/types';

const hydrate: HydrateJSON | undefined = window.hydrateJSON;

function modal(el: HTMLElement, state: 'hide' | 'show')  {
    // @ts-ignore There are no bindings for Bootstrap modal usage
    $(el).modal(state);

    if (state === 'show') {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = '15px';
    } else {
        document.body.style.overflow = 'auto';
        document.body.style.overflowX = 'hidden';
        document.body.style.paddingRight = '0';
    }
}

function onModalHidden(el: HTMLElement, cb: () => void)  {
    // @ts-ignore There are no bindings for Bootstrap modal usage
    $(el).on('hidden.bs.modal', cb);
}

if (!hydrate) {
  console.log('hydrate missing');
}

let dayPassElement: HTMLDivElement;
let successElement: HTMLDivElement;
let tryAgainElement: HTMLDivElement;

let successModal: ModalBookingSuccess | undefined;
function openSuccessModal(props: Record<string, any> | undefined) {
  successModal = new ModalBookingSuccess({
    target: document.body,
    props: {
      hydrate,
      ...props,

      onReady(el: HTMLDivElement) {
        successElement = el;
        onModalHidden(successElement, () => {
        })
        modal(successElement, 'show');
      },
      onClose() {
        modal(successElement, 'hide');
      },
    }
  });
}

let tryAgainModal: BuyGlobalPassModal | undefined;
function openTryAgainModal(props: Record<string, any> | undefined) {
  tryAgainModal = new ModalBookingTryAgain({
    target: document.body,
    props: {
      hydrate,
      ...props,

      onReady(el: HTMLDivElement) {
        tryAgainElement = el;
        onModalHidden(tryAgainElement, () => {
          tryAgainModal?.$destroy();
        })
        modal(tryAgainElement, 'show');
      },
      onClose() {
        modal(tryAgainElement, 'hide');
      },
    }
  });

}



let dayPassModal: BuyGlobalPassModal | undefined;
export function openBuyGlobalPassModal() {
  if (dayPassModal != null) return;

  dayPassModal = new BuyGlobalPassModal({
    target: document.body,
    props: {
      hydrate,

      onReady(el: HTMLDivElement) {
        dayPassElement = el;
        onModalHidden(dayPassElement, () => {
          dayPassModal?.$destroy();
          dayPassModal = undefined;
        })
        modal(dayPassElement, 'show');
      },
      onClose() {
        modal(dayPassElement, 'hide');
      },
      onSuccess(responseData: Response) {
        modal(dayPassElement, 'hide');

        const hasMultiplePasses = responseData.duration_qty > 1 || responseData.capacity > 1;
        openSuccessModal({
          title: `Global ${hasMultiplePasses ? 'Passes' : 'Pass'} Reserved!`,
          message: `Your booking deposit of $${responseData.amount_paid_usd}USD has been purchased!`,
          responseData,
        })
      },
      onError(responseData?: Response) {
        openTryAgainModal({
          technicalError: responseData == null
        });
      },
    }
  });
}